export type CompareFunc = (a: string, b: string) => number;

type CompareObject<T extends object> = { [K in keyof T]: string };

/**
 * Compares two equal objects of optional and inferred keys with
 * corresponding string values. The key/value pairs are compared with a
 * prioritization inferred from the order of keys in objA.
 * */
export const compareByMultiple = <T extends object>(
  objA: CompareObject<T>,
  objB: CompareObject<T>,
  compare: CompareFunc,
): number => {
  const objKeys = Object.keys(objA);

  let compareResult = 0;
  for (const keyWithoutType of objKeys) {
    const key = keyWithoutType as keyof T;
    const valueA = objA[key];
    const valueB = objB[key];

    compareResult = compare(valueA, valueB);

    if (compareResult !== 0) break;
  }

  return compareResult;
};
